import type { StageBarKey } from "./StageBar"

export type FlowColorKey = StageBarKey | "behind"

export const FLOW_COLOR: Record<FlowColorKey, string> = {
    new: "rgb(var(--ink) / 0.14)",
    booked: "rgb(var(--ink) / 0.28)",
    onHold: "rgb(var(--ink) / 0.08)",
    inTransit: "rgb(var(--ink) / 0.48)",
    delivered: "rgb(var(--dot-green))",
    behind: "rgb(var(--dot-amber))",
}
